import(/* webpackMode: "eager" */ "/tmp/build_81f94c18/src/app/encomendas/layout.tsx");
